import React from 'react'
import { InboxIcon } from 'lucide-react'
import styles from './EmptyState.module.scss'

interface EmptyStateProps {
  title?: string
  description?: string
  action?: React.ReactNode
  className?: never
}

export const EmptyState: React.FC<EmptyStateProps> = ({
  title = 'No results',
  description = 'Nothing to show here yet.',
  action,
}) => (
  <div className={styles.container}>
    <InboxIcon className={styles.icon} />
    <p className={styles.title}>{title}</p>
    <p className={styles.description}>{description}</p>
    {action && <div className={styles.action}>{action}</div>}
  </div>
)
